module.exports = __webpack_public_path__ + "fonts/montserrat-extraBold.6bf17403f884285592f77a335b827914.woff";